fx.ns("models", class Theme extends fx.Model {

	constructor(data)
	{
		super(data);
    }

	get defaults()
    {
        return {
            selected: false
        }
    }

    delete(force)
	{
		if (!force)
			this.event("confirm-delete-theme", this);
		else
		{
			if (this.status == "ready")
			{
				this.event("theme-ready-not-removable", this);
			}
			else
				super.delete();
		}
	}

	select()
	{
		this.selected = true;
	}

	get propertiesNotStorable()
    {
        return ["thumb_square", "thumb_landscape", "thumb_portrait", "id"];
    }
	
});